/** --------------------------------------------------------
 * Author Tien Tran
 * Email tientran0019@gmail.com
 * Phone 0972970075
 *
 * Created: 2024-06-21 10:54:23

 * Last updated on: 2024-06-21 10:54:23
 * Last updated by: Tien Tran
 *------------------------------------------------------- */

"use client";

import { confirmable, createConfirmation } from "react-confirm";

import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogProps,
	DialogTitle,
} from "@mui/material";

import { ThemeProvider } from "@onair/config-mui";

type PropTypes = DialogProps & {
	okLabel?: string;
	cancelLabel?: string;
	title?: string;
	content: string;
	show: boolean;
	proceed: (v: boolean) => void;
	dismiss: () => void;
	cancel: (value?: any) => void;
	enableEscape?: boolean;
	enableBackdropClick?: boolean;
};

const Modal = (props: PropTypes) => {
	const {
		okLabel = "Có",
		cancelLabel = "Không",
		title = "Xác nhận",
		content,
		show,
		proceed,
		dismiss,
		cancel,
		enableEscape = true,
		enableBackdropClick = true,
		...others
	} = props;

	return (
		<ThemeProvider>
			<Dialog
				aria-labelledby={title}
				aria-describedby={content}
				fullWidth
				maxWidth="xs"
				{...others}
				open={show}
				onClose={() => (enableBackdropClick ? cancel() : null)}
				disableEscapeKeyDown={!enableEscape}
				sx={{
					zIndex: 2147483648,
				}}
			>
				<DialogTitle>{title}</DialogTitle>
				<DialogContent>
					<DialogContentText>{content}</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button autoFocus onClick={cancel}>
						{cancelLabel}
					</Button>
					<Button
						onClick={proceed}
						autoFocus
						color="primary"
						variant="contained"
					>
						{okLabel}
					</Button>
				</DialogActions>
			</Dialog>
		</ThemeProvider>
	);
};

const confirm = (
	content = "Bạn có chắc chắn không?",
	options?: Partial<PropTypes>,
) => {
	return createConfirmation(confirmable(Modal))({
		content,
		...options,
	} as PropTypes);
};

export default confirm;
